export default "__VITE_ASSET__DzWxIXJb__"